import React from 'react';
import { Link } from 'react-router-dom';
import { brand, navLinks } from '../../mock';
import { ShieldCheck, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Lock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-slate-950 text-slate-300 mt-16">
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
                <ShieldCheck className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="font-serif-display text-xl text-white">THE LOAN ALLIANCE</div>
                <div className="text-[10px] uppercase tracking-widest text-emerald-400">Compare. Choose. Save.</div>
              </div>
            </Link>
            <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
              {brand.tagline} Independent, editor-led comparisons of personal loans, credit protection plans, credit builders, and wealth-building products — so you can pick with confidence.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-md bg-slate-800/60 hover:bg-emerald-600 border border-slate-700 hover:border-emerald-500 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <div className="mt-6 flex items-center gap-4 text-xs text-slate-400">
              <span className="flex items-center gap-1.5"><Lock className="w-3.5 h-3.5 text-emerald-400" /> 256-bit Encryption</span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 hover:text-emerald-400 transition-colors">{link.label}</Link>
                </li>
              ))}
              <li><Link to="/privacy-policy" className="text-slate-400 hover:text-emerald-400 transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/loan" className="text-slate-400 hover:text-emerald-400">Personal Loans</Link></li>
              <li><Link to="/protect-credit" className="text-slate-400 hover:text-emerald-400">Credit Protection</Link></li>
              <li><Link to="/build-credit" className="text-slate-400 hover:text-emerald-400">Credit Building</Link></li>
              <li><Link to="/how-it-works" className="text-slate-400 hover:text-emerald-400">How It Works</Link></li>
              <li><Link to="/faq" className="text-slate-400 hover:text-emerald-400">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5 text-slate-400">
                <Mail className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                <a href={`mailto:${brand.email}`} className="hover:text-emerald-400 break-all">{brand.email}</a>
              </li>
              <li className="flex items-start gap-2.5 text-slate-400">
                <MapPin className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
                <span>{brand.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="grid md:grid-cols-2 gap-6 items-start">
            <div className="text-xs text-slate-500 leading-relaxed">
              <p className="font-semibold text-slate-400 mb-1">Advertising & Partnership Disclosure</p>
              This website contains advertisements and marketing links from our financial partners. We may receive compensation if you click on links and/or make purchases. All opinions expressed are our own.
            </div>
            <div className="text-xs text-slate-500 leading-relaxed">
              <p className="font-semibold text-slate-400 mb-1">Information Disclaimer</p>
              Information is for educational purposes only. Consult qualified professionals before making financial decisions. Last Updated: July, 2025.
            </div>
          </div>
          <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-3 pt-6 border-t border-slate-800/70 text-xs text-slate-500">
            <p>© {new Date().getFullYear()} The Loan Alliance. All rights reserved.</p>
            <p>Made for financial freedom. Built with trust.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
